export default function MailSvg() {
  return (
    <svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.25 0h13.5a3.25 3.25 0 0 1 3.245 3.066L20 3.25v9.5a3.25 3.25 0 0 1-3.066 3.245L16.75 16H3.25a3.25 3.25 0 0 1-3.245-3.066L0 12.75v-9.5A3.25 3.25 0 0 1 3.066.005L3.25 0h13.5-13.5zM18.5 5.373l-8.15 4.29a.75.75 0 0 1-.603.043l-.096-.042L1.5 5.374v7.376a1.75 1.75 0 0 0 1.606 1.744l.144.006h13.5a1.75 1.75 0 0 0 1.744-1.607l.006-.143V5.373zM16.75 1.5H3.25a1.75 1.75 0 0 0-1.744 1.606L1.5 3.25v.429L10 8.152l8.5-4.474V3.25a1.75 1.75 0 0 0-1.607-1.744L16.75 1.5z"
        fill="#0E3D57"/>
    </svg>
  );
}
